import React, { useState, useEffect } from 'react';
import { TextField } from '@mui/material';

import { BaseLabel, AutoCompleteSmall, RowContainer, Checkbox, Label } from '../../../../styles/styleUtils';
import { getOperadoras, getBandeiras } from '../../../api';

function CreditoDetalhes({ formData, onAutoCompleteChange, setFormData }) {
  const [operadoras, setOperadoras] = useState([]);
  const [bandeiras, setBandeiras] = useState([]);

  const fetchData = async () => {
    const result = await getOperadoras();
    setOperadoras(result);
    const result2 = await getBandeiras();
    setBandeiras(result2);
  };
  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div>
      <RowContainer>
        <BaseLabel htmlFor="operadora">Operadora</BaseLabel>
        <AutoCompleteSmall
          disablePortal
          id="operadora"
          name="operadora"
          value={formData.operadora || null}
          onChange={(_, value) => onAutoCompleteChange('idOperadora', 'operadora', value)}
          options={operadoras}
          isOptionEqualToValue={(option, value) => option._id === value._id}
          getOptionLabel={(option) => `${option.nome}`}
          renderInput={(params) => <TextField {...params} placeholder="Selecione" />}
          disabled={formData.visualiza}
        />
        { /* formData.operadora && (
          <AutoCompleteSmall
            disablePortal
            id="tipoOperacao"
            name="tipoOperacao"
            value={formData.tipoOperacao || null}
            onChange={(_, value) => onAutoCompleteChange(null, 'tipoOperacao', value)}
            options={formData.operadora.tipoOperacao}
            isOptionEqualToValue={(option, value) => option === value}
            getOptionLabel={(option) => `${option}`}
            renderInput={(params) => <TextField {...params} placeholder="Selecione" />}
          />
        ) */ }
      </RowContainer>
      <RowContainer>
        <BaseLabel htmlFor="operadora">Bandeira</BaseLabel>
        <AutoCompleteSmall
          disablePortal
          id="bandeira"
          name="bandeira"
          value={formData.bandeira || null}
          onChange={(_, value) => onAutoCompleteChange('idBandeira', 'bandeira', value)}
          options={bandeiras}
          isOptionEqualToValue={(option, value) => option._id === value._id}
          getOptionLabel={(option) => `${option.nome}`}
          renderInput={(params) => <TextField {...params} placeholder="Selecione" />}
          disabled={formData.visualiza}
        />
      </RowContainer>
      {formData.formaPagamento && formData.formaPagamento.nome.includes('Parcelado') && (
        <RowContainer>
          <BaseLabel htmlFor="antecipacaoAutomatica">Recebíveis</BaseLabel>
          <Checkbox
            type="checkbox"
            id="antecipacaoAutomatica"
            name="antecipacaoAutomatica"
            checked={formData.antecipacaoAutomatica === 'sim'}
            onChange={(event) =>
              setFormData((prev) => ({
                ...prev,
                antecipacaoAutomatica: event.target.checked ? 'sim' : 'nao',
              }))
            }
            disabled={formData.visualiza}
          />
          <Label htmlFor="antecipacaoAutomatica">Antecipar recebíveis</Label>
        </RowContainer>
      )}
    </div>
  );
}

export default CreditoDetalhes;
